import { OnboardingEvents, trackTagManagerEvent } from 'firebase-client';
import { useTranslation } from 'react-i18next';
import { Box } from 'ui';

import { signPdf } from '~/contract/helpers/signPdf';
import { useCreateContract } from '~/contract/hooks';
import { useDriveFile } from '~/contract/hooks/useDriveFile';
import { useContractApi } from '~/data/api';
import { StepTitle } from '~/ui';

import { SignatureCollector } from '../shared';

export const ContractSignStep = () => {
  const { t } = useTranslation('createContractWizard');

  const { goToNextStep, setSignedContract, getContractData } = useCreateContract();
  const { fileContent: file, loading: fileLoading } = useDriveFile();
  const { uploadContract } = useContractApi();

  const contractData = getContractData();

  const onSign = async (base64PngSignature: string) => {
    trackTagManagerEvent(OnboardingEvents.contractSign);

    const arrayBuffer = await file.arrayBuffer();
    const signedPdf = await signPdf(base64PngSignature, arrayBuffer);

    await uploadContract({
      contractNumber: contractData.contractNumber,
      uploadFile: Buffer.from(signedPdf).toString('base64'),
    });

    setSignedContract(signedPdf);

    goToNextStep();
  };

  return (
    <Box flex={1} display="flex" flexDirection="column">
      <StepTitle>{t('sign.title')}</StepTitle>
      <Box flex={1} display="flex" flexDirection="column" mt={2}>
        <SignatureCollector isFileLoaded={!fileLoading} onSign={onSign} />
      </Box>
    </Box>
  );
};
